export default {
	title: null,
};
